import { FieldValues } from "react-hook-form";

import { SelectProps } from "../../form_components/Inputs";
import { StageDropdownSelect } from "./StageDropdownSelect";
import { GroupedStageOptions, StageOption } from "./types";

export interface GroupedStageOption extends StageOption {
  transitionGroup: string;
}

export interface ExtendedGroupedStageOptions extends Omit<GroupedStageOptions, "options"> {
  options: GroupedStageOption[];
}

type GroupedStageDropdownSelectProps<T extends FieldValues> = Omit<
  SelectProps<T>,
  "options" | "onChange"
> & {
  options: ExtendedGroupedStageOptions[];
  loading?: boolean;
  fillbackground?: boolean;
  onChange?: (value: string, option?: GroupedStageOption) => void;
  preventFormValueChange?: boolean;
};

export function GroupedStageDropdownSelect<T extends FieldValues>(
  props: GroupedStageDropdownSelectProps<T>,
) {
  const { onChange, options, ...restProps } = props;

  return (
    <StageDropdownSelect
      {...restProps}
      options={options}
      onChange={(value, baseOption) => {
        if (onChange && baseOption) {
          // Find the full option with transitionGroup
          const flatOptions = options.flatMap((group) => group.options);
          const fullOption = flatOptions.find((opt) => opt.value === baseOption.value);
          if (fullOption) {
            onChange(value, fullOption);
          }
        }
      }}
    />
  );
}
